import { put, select } from 'redux-saga/effects'

import history from '../_history'
import { auth } from '../constants/actions'
import { API_BASE_URL } from '../constants/common'
import routes from '../constants/routes/routes'
import { getJwtToken } from '../selectors'
import { formatURLParam } from './common'

export function* request({ method, url, urlOverride, endpointId, params, data = null, headers, isFormData }) {
  // Update the code so that the endpoints are sent as ID, and the url is api/request.
  const token = yield select(getJwtToken) || null
  const options = {
    method: 'POST',
    headers:
      headers || isFormData
        ? {}
        : {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: token,
          },
  }

  const requestBody = {
    data,
    endpointId,
    params,
    method,
    headers:
      headers || isFormData
        ? {}
        : {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: token,
          },
  }

  options.body = JSON.stringify(requestBody)
  try {
    const baseUrl = urlOverride ? url : API_BASE_URL
    const response = yield fetch(baseUrl, options)
    const responseData = yield response.json()

    if (responseData.token) {
      // set token
      yield put(auth.setToken(responseData.token))
    }

    const errMsg = responseData.errorMessage || ''

    if (response.status === 401 && errMsg.match(/invalid|expired/) && !errMsg.match(/password/)) {
      // go to sign in
      yield put(auth.signout())
      return history.push({
        pathname: routes.login.path,
        search: history.location.search,
      })
    }
    return {
      status: response.status,
      ...responseData,
    }
  } catch (err) {
    return {
      status: 500,
      success: false,
      error: err,
    }
  }
}

export const buildUrl = (endpoint, params = {}, urlOverride = null) => {
  const p = formatURLParam(params)
  const query = p.length > 0 ? `?${p}` : ''
  return urlOverride || `api/${endpoint}${query}`
}

export function* get({ endpointId, params = {}, headers }) {
  const response = yield request({
    method: 'GET',
    endpointId,
    params,
    headers,
  })
  return response
}

// biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
export function* post({ endpoint, endpointId, data = {}, params = {}, urlOverride = null, headers, isFormData }) {
  const response = yield request({
    method: 'POST',
    url: endpoint,
    endpointId,
    params,
    headers,
    isFormData,
    data,
  })
  return response
}

export function* checkAuth() {
  const response = yield request({
    method: 'GET',
    url: '/auth/check', // This is required to fire app.use('/auth/check')
    urlOverride: true,
  })
  return response
}
